import { FC } from 'react'
import { TextField, Stack } from '@mui/material'
import { useVerificationCode } from '../_hooks/useVerificationCode'
import { COLOR_PALLETE } from '~/COLOR_PALLETE'

type VerificationCodeInputProps = {
  value: string
  onChange: (newValue: string) => void
  // Custom class name that should be dynamically sent according to the loading, succes, error states of the verify API call
  className?: string
  stateClassName?: string
}

export const VerificationCodeInput: FC<VerificationCodeInputProps> = ({
  value,
  onChange,
  className = '',
  stateClassName,
}) => {
  const { inputValues, handleChange, handleKeyDown, inputRefs, handleFocus } =
    useVerificationCode(value, onChange)

  const classState = () => {
    if (stateClassName === 'success') return COLOR_PALLETE.zGreen500
    if (stateClassName === 'error') return COLOR_PALLETE.zRedError
  }

  return (
    <Stack className={`flex-row gap-2 mx-auto ${className}`}>
      {/* Render 4 input fields for the verification code */}
      {inputValues.map((val, index) => (
        <TextField
          key={`${index}-${val}`}
          value={val}
          onChange={(e) =>
            handleChange(e as React.ChangeEvent<HTMLInputElement>, index)
          }
          onKeyDown={(e) => handleKeyDown(e, index)}
          inputRef={(el) => (inputRefs.current[index] = el)} // Set ref for focus management
          onFocus={(e) => handleFocus(e as React.FocusEvent<HTMLInputElement>)}
          inputMode="numeric"
          type="tel"
          sx={(theme) => ({
            width: '100%',
            maxWidth: '80px',
            height: '80px',
            borderRadius: '20px',
            justifyContent: 'center',
            background: theme.palette.custom.zGrey200,
            boxShadow: `inset 0 0 0 2px ${classState()}`,
            '&:focus-within': {
              boxShadow: `inset 0 0 0 2px ${theme.palette.custom.zBlue400}`,
            },
            '& .MuiInputBase-input': {
              height: '40px',
              fontSize: '32px !important',
              fontWeight: '500 !important',
              textAlign: 'center',
            },
          })}
        />
      ))}
    </Stack>
  )
}
